import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  actions: {
    async getAppointment({ commit, state }, appointmentId) {
      try {
        let appointment = (await Vue.http.get(this.state.baseUrl + '/appointments/' + appointmentId)).data
        commit('setState', { stateName: 'appointment', stateValue: appointment })
        return appointment
      } catch (e) {
        console.log(e)
      }
    },
    async getAppointmentById({ commit, state }, appointmentId) {
      try {
        let appointment = (await Vue.http.get(this.state.baseUrl + '/appointments/' + appointmentId)).data
        return appointment
      } catch (e) {
        console.log(e)
      }
    },
    async getAppointmentMessages({ }, appointmentId) {
      try {
        let response = await Vue.http.get(this.state.baseUrl + '/appointmentmessages/' + appointmentId)

        if (response && response.data) {
          return response.data
        }
        else {
          return null
        }
      } catch (e) {
        console.log(e)
      }
    },
    async getAppointmentsForDoctor({ state }, options) {
      try {
        //Get all the live, telestroke appointments for this doctor
        let response = (await Vue.http.get(this.state.baseUrl + '/appointments/doctor/' + options.userId + '?pageSize=' + (options.pageSize || 3) + '&pageNumber=' + options.pageNumber)).data

        //If the provider is secondary and has declined the appointment, Remove that appointment from the list
        response.data.forEach(function (appt, index) {
          if (appt.secondaryProviders && appt.secondaryProviders.length > 0) {
            appt.secondaryProviders.forEach(function (provider) {
              if (provider.providerId == options.userId) {
                if (provider.status[provider.status.length - 1] == 'declined') {
                  response.data.splice(index, 1)
                }
              }
            });
          }
        });

        return response
      } catch (e) {
        console.log(e)
      }
    },
    async getNurseAppointmentsByEndpoint({ state }, endpoint) {
      return (await Vue.http.get(this.state.baseUrl + '/appointments/nurse/' + endpoint)).data || []

    },

    async getNurseDiscussionAppointmentsByEndpoint({ state }, endpoint) {
      return (await Vue.http.get(this.state.baseUrl + '/appointments/nurse/discussion/' + endpoint)).data || []
    },

    async getCompletedAppointments({ state }, options) {
      return (await Vue.http.post(this.state.baseUrl + '/appointments/doctor/previous/bydate?pageSize=' + (options.pageSize || 2) + '&pageNumber=' + options.pageNumber, {
        providerId: options.doctorId,
        dateDetails: options.dateDetails,
        POSTPONED_APPOINTMENTS: options.POSTPONED_APPOINTMENTS || false,
        statusCheckArray: options.statusCheckArray || null,
        appointmentType: options.appointmentType || null,
        ucRecordings: options.ucRecordings
      })).data
    },
    async getCompletedAppointmentsForNurse({ state }, options) {
      return (await Vue.http.post(this.state.baseUrl + '/appointments/completed?pageSize=' + (options.pageSize || 2) + '&pageNumber=' + (options.pageNumber || 1), {
        endpointId: options.endpoint,
        dateStart: options.dateStart,
        dateEnd: options.dateEnd,
        POSTPONED_APPOINTMENTS: options.POSTPONED_APPOINTMENTS || false,
      })).data
    },
    async getScheduledAppointments({ state }, options) {
      try {
        return (await Vue.http.post(this.state.baseUrl + '/appointments/scheduled/query?pageSize=' + (options.pageSize || 2) + '&pageNumber=' + options.pageNumber, options.filter)).data || []
      } catch (e) {
        console.log(e)
        throw e
      }
    },
    async getLiveAndScheduledAppointments({ state }, options) {
      try {
        return (await Vue.http.post(this.state.baseUrl + '/appointments/scheduledandlive/query?pageNumber=' + options.pageNumber + '&pageSize=' + options.pageSize, options.filter)).data || []
      } catch (e) {
        console.log(e)
        throw e
      }
    },
    async updateDoctorForAppointment({ state }, data) {
      try {
        return (await Vue.http.put(this.state.baseUrl + '/appointments/update/provider/' + data.appointmentId, {
          provider: data.provider,
          billingDetails: data.billingDetails
        })).data || null
      } catch (e) {
        console.log(e)
        throw e
      }
    },
    async updateStatus({ state }, data) {
      try {
        return (await Vue.http.put(this.state.baseUrl + '/appointments/update/status/' + data.appointmentId, { appointmentStatus: data.status })).data
      } catch (e) {
        console.log(e)
        throw e
      }
    },
    async updateStatusOnJoin({ state }, data) {
      try {
        return (await Vue.http.put(this.state.baseUrl + '/appointments/scheduled/update/status/onJoin/' + data.appointmentId, {})).data
      } catch (e) {
        console.log(e)
        throw e
      }
    },
    async updateAttendant({ state }, data) {
      try {
        return (await Vue.http.put(this.state.baseUrl + '/appointments/update/attendant/' + data.appointmentId, { attendant: data.attendant })).data
      } catch (e) {
        console.log(e)
        throw e
      }
    },

    async updateStatusSecondaryProvider({ state }, data) {
      try {
        return (await Vue.http.put(this.state.baseUrl + '/appointments/update/provider/secondary/status/' + data.appointmentId, { providerId: data.providerId, status: data.staus })).data
      } catch (e) {
        console.log(e)
        throw e
      }
    },
    async updateAppointment({ state }, appointment) {
      return (await Vue.http.put(this.state.baseUrl + '/appointments/' + appointment._id, appointment)).data
    },
    async updateCallStatus({ }, options) {
      return (await Vue.http.put(this.state.baseUrl + '/appointmentmessages/callstatus/' + options.appointmentId, options)).data
    },
    async getRecordings({ state }, options) {
      try {
        let res = (await Vue.http.post(this.state.settings.vMaatuSettings.ucServiceSocketUrl + '/api/rooms/recordings', options, {
          auth: {
            username: "admin",
            password: "Carenation@123",
          },
        })).data;
        return res
      } catch (e) {
        throw e
      }
      /*  return (await Vue.http.post(this.state.baseUrl + '/appointments/ucrecordings/_fetch', options)).data */
    },
    async updateFeedback({ state }, options) {
      let apiUrl = options.IS_PATIENT_FEEDBACK ? '/appointments/update/patientfeedback/' : '/appointments/update/doctorfeedback/'
      return (await Vue.http.post(this.state.baseUrl + apiUrl + options.appointmentId, options.feedback)).data
    },
    async updateVitals({ state }, options) {
      return (await Vue.http.put(this.state.baseUrl + "/appointments/update/vitals/" + options.appointmentId, {
        vitals: options.vitals
      }))
    },
    async createAppointment({ state }, appointment) {
      return (await Vue.http.post(this.state.baseUrl + '/appointments', appointment)).data
    },
    async createNurseAppointment({ state }, appointment) {
      return (await Vue.http.post(this.state.baseUrl + '/appointments/nurse', appointment)).data
    },
    async getInprogreesAppointment({ state }, options) {
      let data = (await Vue.http.get(this.state.baseUrl + '/appointments/inprogress/' + options.endpoint.name)).data
      return data
    },
    async endAppointment({ state }, options) {
      let data = (await Vue.http.put(this.state.baseUrl + '/appointments/' + options.response[0]._id, options.response[0])).data
      return data
    },
    async getLatestAppointment({ state }, options) {
      let data = (await Vue.http.get(this.state.baseUrl + '/appointments/' + options.appointment._id)).data
      return data
    },
    async emailReceipt({ state }, data) {
      try {
        return (await Vue.http.post(this.state.baseUrl + '/appointments/receipt/notification', data)).data
      } catch (e) {
        console.log(e)
      }
    },
    //Care Coordinator
    async getAppointmentsForCareco({ state }, user) {
      return (await Vue.http.post(this.state.baseUrl + '/appointments/careCoordinator/' + user._id, {
        caregroupIds: user.caregroups.map((caregroup) => {
          return caregroup
        })
      })).data
    },
    async getAppointmentsByDoctorIds({ state }, options) {
      return (await Vue.http.post(this.state.baseUrl + '/appointments/doctorIds/', options)).data
    },
    async validateAppointmentRequest({ state }, appointmentId) {
      return (await Vue.http.get(this.state.baseUrl + '/appointments/carecoordinator/' + appointmentId + '/_validate')).data
    },

    //Patient
    async getAhcAppointments({ commit }, patientId) {
      try {
        let appointments = (await Vue.http.get(this.state.baseUrl + '/appointments/ahc/patient/' + patientId)).data

        if (appointments && appointments.length > 0) {
          appointments = appointments.filter((appt) => {
            return appt.latestStatus != 'Completed'
          })
          commit('setState', { stateName: 'ahcAppointments', stateValue: appointments })
          return appointments
        }
        else {
          return null
        }

      } catch (e) {
        console.log(e)
        return null
      }
    },
    async requestAppointment({ }, appointment) {
      return (await Vue.http.post(this.state.baseUrl + '/appointments/request', {
        appointmentDetails: appointment
      })).data
    },

    async requestTrainingConsultation({ }, appointment) {
      return (await Vue.http.post(this.state.baseUrl + '/appointments/training/request', {
        appointmentDetails: appointment
      })).data
    },

    async markAppointmentAsPaid({ state }, appointmentId) {
      return (await Vue.http.get(this.state.baseUrl + '/appointments/amountpaid/' + appointmentId)).data
    },
    async blockAppointment({ state }, options) {
      try {
        return (await Vue.http.post(this.state.baseUrl + '/appointments/create/tempappt', {
          doctorId: this.state.selectedDoctor._id,
          endpoint: (this.state.selectedEndpoint && this.state.selectedEndpoint.name) ? this.state.selectedEndpoint.name : null,
          patient: options.patient,
          reason: options.reason,
          consultationType: options.consultationType,
          slot: {
            start: this.state.selectedSlot.start,
            end: this.state.selectedSlot.end
          },
          createdBy: options.createdBy,
          SAVE_PATIENT: options.SAVE_PATIENT
        })).data
      } catch (e) {
        throw (e)
      }
    },
    async confirmAppointment({ state }, options) {
      try {
        return (await Vue.http.get(this.state.baseUrl + '/appointments/confirm/' + options.appointmentId)).data
      } catch (e) {
        console.log(e)
        return null
      }
    },
    async searchReasons({ state }, options) {
      return (await Vue.http.get(this.state.baseUrl + '/reasons/search/:' + options.query)).data
    },
    async getMostFrequentReasons({ }, options) {
      return (await Vue.http.get(this.state.baseUrl + '/reasons')).data
    },

    async getAppointmentStats({ }, options) {
      let response = (await Vue.http.post(this.state.baseUrl + '/appointments/stats', options)).data
      return response
    },

    async saveAppointmentReferenceToDiscussion({ }, options) {
      let response = (await Vue.http.post(this.state.baseUrl + '/appointments/' + options.discussionId + '/currentappointmentref/_add', options)).data
      return response
    },

    async removeAppointmentReferenceFromDiscussion({ }, options) {
      let response = (await Vue.http.get(this.state.baseUrl + '/appointments/' + options.discussionId + '/currentappointmentref/_remove')).data
      return response
    },

    async registerPatientForER({ state }, options) {
      return (await Vue.http.post(this.state.baseUrl + '/emergencyroomencounters/' + options.erEncounterId + '/registerPatient', options.patientDetails)).data
    },

    async updateErPatient({ state }, appointment) {
      return (await Vue.http.put(this.state.baseUrl + '/emergencyroomencounters/' + appointment._id, appointment)).data
    },

    async createEmergencyRoomEncounter({ state }, appointment) {
      return (await Vue.http.post(this.state.baseUrl + '/emergencyroomencounters', appointment)).data
    },

    async updateEmergencyRoomEncounter({ state }, appointment) {
      return (await Vue.http.put(this.state.baseUrl + '/emergencyroomencounters/' + appointment._id, appointment)).data
    },

    async getNurseErEncountersByEndpoint({ state }, endpoint) {
      return (await Vue.http.get(this.state.baseUrl + '/emergencyroomencounters/nurse/' + endpoint)).data || []
    },

    async filterNurseErEncountersByEndpoint({ state }, options) {
      return (await Vue.http.post(this.state.baseUrl + '/emergencyroomencounters/nurse/_filter', options)).data || []
    },

    async updateErEncounterStatus({ state }, data) {
      try {
        return (await Vue.http.put(this.state.baseUrl + '/emergencyroomencounters/update/status/' + data.emergencyRoomEncounterId, { status: data.status })).data
      } catch (e) {
        console.log(e)
        throw e
      }
    },

    async getInformedConsents({ state }) {
      return (await Vue.http.get(this.state.baseUrl + '/informedconsents')).data || []
    },
    async notifyAppointment({ }, options) {
      return (await Vue.http.post(this.state.baseUrl + `/appointments/${options.appointmentId}/_notify`, options)).data
    },
  }
}
